export class NICEDialerGeneralSettings {
    minimumRetryMinutes:	number;
    // minimum: 1
    // maximum: 50000
    maximumAttempts:	number;
    // minimum: 1
    // maximum: 300
    defaultContactExpiration:	number;
    // minimum: 1
    // maximum: 527039
    getPriorityContactsOnContactInsertion:	boolean;
    loadCallbacks:	boolean;
    loadFresh:	boolean;
    loadNonFresh:	boolean;
    overrideBusinessUnitAbandonRate:	boolean;
    maximumRingingDuration:	number;
    // minimum: 1
    // maximum: 60
    beginDampenPercentage:	number;
    // minimum: 0
    // maximum: 100
    abandonRateCutoff:	number;
    // minimum: 0
    // maximum: 100
    abandonRateThreshold:	number;
    // minimum: 0
    // maximum: 99.9
    inactiveBlenderTimer:	number;
    // minimum: 15
    // maximum: 999
    maximumRatio:	number;
    aggressiveness:	string;
    endOfListNotificationsDelay:	number;
    // minimum: 0
    // maximum: 3600
    notifyAgentsWhenListIsEmpty:	boolean;
    percentageOfAgentsBeforeOverdial:	number;
    // minimum: 0
    // maximum: 100
    blockMultipleCalls:	boolean;
    consecutiveAttemptsWithoutALiveConnect:	number;
    // minimum: 1
    // maximum: 999
    enableDialingByProficiency:	boolean;
    proficiencyFactor:	number;
    waitTimeFactor:	number;
    maxConcurrentCallsPerAgent:	number;
    maxWaitTimeSeconds:	number;

    constructor(jsonObject?) {
        if (jsonObject) {
            this.minimumRetryMinutes = +jsonObject?.minimumRetryMinutes || 0;
            this.maximumAttempts = jsonObject?.maximumAttempts || 1;
            this.defaultContactExpiration = jsonObject?.defaultContactExpiration || 1;
            this.getPriorityContactsOnContactInsertion = jsonObject?.getPriorityContactsOnContactInsertion || false;
            this.loadCallbacks = jsonObject?.loadCallbacks || false;
            this.loadFresh = jsonObject?.loadFresh || false;
            this.loadNonFresh = jsonObject?.loadNonFresh || false;
            this.overrideBusinessUnitAbandonRate = jsonObject?.overrideBusinessUnitAbandonRate || false;
            this.maximumRingingDuration = jsonObject?.maximumRingingDuration || 1;
            this.beginDampenPercentage = jsonObject?.beginDampenPercentage || 1;
            this.abandonRateCutoff = jsonObject?.abandonRateCutoff || 1;
            this.abandonRateThreshold = jsonObject?.abandonRateThreshold || 1;
            this.inactiveBlenderTimer = jsonObject?.inactiveBlenderTimer || 1;
            this.maximumRatio = jsonObject?.maximumRatio || 1;
            this.aggressiveness = jsonObject?.aggressiveness || '';
            this.endOfListNotificationsDelay = jsonObject?.endOfListNotificationsDelay || 1;
            this.notifyAgentsWhenListIsEmpty = jsonObject?.notifyAgentsWhenListIsEmpty || false;
            this.percentageOfAgentsBeforeOverdial = jsonObject?.percentageOfAgentsBeforeOverdial || 1;
            this.blockMultipleCalls = jsonObject?.blockMultipleCalls || false;
            this.consecutiveAttemptsWithoutALiveConnect = jsonObject?.consecutiveAttemptsWithoutALiveConnect || 1;
            this.enableDialingByProficiency = jsonObject?.enableDialingByProficiency || false;
            this.proficiencyFactor = jsonObject?.proficiencyFactor || 1;
            this.waitTimeFactor = jsonObject?.waitTimeFactor || 1;
            this.maxConcurrentCallsPerAgent = jsonObject?.maxConcurrentCallsPerAgent || 1;
            this.maxWaitTimeSeconds = jsonObject?.maxWaitTimeSeconds || 1;
        }
    }
}

